import React, { useState, useEffect } from "react" ;

import OrgDashAppSidebar from "root/Wieldy/ApplicationModules/OrganisationDashboard/Sidebar/OrgDashAppSidebar";
import OrgDashAppBody from "root/Wieldy/ApplicationModules/OrganisationDashboard/Body/OrgDashAppBody";
import OrgDashAppDrawer from "root/Wieldy/ApplicationModules/OrganisationDashboard/Body/OrgDashAppDrawer";

const WieldyApplicationModuleOrgDash = (props) =>
{
    const [ height, setHeight ] = useState ( props.height ) ;
    const [ width, setWidth] = useState ( props.width ) ;
    const pageStyle = { height: '' + (+height-1) + 'px' } ;

    useEffect(() => {
        setHeight(props.height);
        setWidth(props.width);
    }, [props.height, props.width]);

    return (
        <div className="row">
            <div className="col-xl-12">

                <div className="dt-module" style={pageStyle}>

                    <OrgDashAppSidebar title={'Dashboard'} iconName={'icon-dashboard'} height={height} width={width}/>
                    <OrgDashAppBody height={height}/>

                    { /* <OrgDashAppDrawer /> */ }

                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModuleOrgDash;